/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Group_Type_LabelInputs */



/**
* | output |
* | --- |
* | "New Group Type" |
*
* @param {New_Project_Group_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_group_type_label = /** @type {((inputs?: New_Project_Group_Type_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Group_Type_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouveau type de groupe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuer Gruppentyp")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo tipo di gruppo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новый тип группы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nuevo tipo de grupo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新组类型")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいグループタイプ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया समूह प्रकार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novo tipo de grupo")
	return /** @type {LocalizedString} */ ("New Group Type")
});